import { ImageFileIcon, ImageFileIconProps } from "../ImageFileIcon"

export const WhiteMapIcon = ({ containerClasses, iconSize }: ImageFileIconProps) => {
    return (
        <ImageFileIcon
            id="White-map-icon"
            imageFilePath="/images/maps/white.jpg"
            containerClasses={containerClasses}
            iconSize={iconSize}
        />
    )
}

export default WhiteMapIcon
